import { useState, useEffect } from 'react';
import {
  MONTANA_PRICING_TIERS,
  MONTANA_VIDEO_DEMOS,
  MONTANA_TESTIMONIALS,
  MONTANA_FAQS,
  COMPETITOR_COMPARISON,
} from '@/utils/entities/city/montana';

export const useMontanaData = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate data loading (in a real app, this might fetch from an API)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return {
    pricingTiers: MONTANA_PRICING_TIERS,
    videoDemos: MONTANA_VIDEO_DEMOS,
    testimonials: MONTANA_TESTIMONIALS,
    faqs: MONTANA_FAQS,
    competitorComparison: COMPETITOR_COMPARISON,
    isLoading,
  };
};
